import React, { useEffect, useState } from 'react';

import styles from './HealthCardAtaksiDistributionYear.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../../Auth';
import { useAxios } from '../../../../../../../AxiosHandler';
import LineGraphCard from '../../../../Cards/LineGraphCard/LineGraphCard';

function HealthCardAtaksiDistributionYear(props: HealthCardAtaksiDistributionYearProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();
    
    function getData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/ataksi/breed/" + auth.selectedBreed + "/distributionyear",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            let lowestYear = res.data?.length > 0 ? res.data[0]["YEAR"] : 0;
            let highestYear = res.data?.length > 0 ? res.data[res.data.length - 1]["YEAR"] : 0;
            let allYears = Array.from({ length: highestYear - lowestYear + 1 }, (_, i) => lowestYear + i);

            if (res.data?.length > 0) {
                setData({
                    labels: allYears,
                    datasets: [
                        {
                            label: t("statistics.areas.health.graphs.ataksi.distributionyear.datasets.label_free"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#68DB5A",
                            borderColor: "#68DB5A",
                            pointRadius: 2,
                            data: allYears.map((j: any) => res.data.find((k: any) => k["YEAR"] == j)?.["FRI"] || 0),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.health.graphs.ataksi.distributionyear.datasets.label_carrier"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#FFE144",
                            borderColor: "#FFE144",
                            pointRadius: 2,
                            data: allYears.map((j: any) => res.data.find((k: any) => k["YEAR"] == j)?.["BAERER"] || 0),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.health.graphs.ataksi.distributionyear.datasets.label_afflicted"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#ff2f45",
                            borderColor: "#ff2f45",
                            pointRadius: 2,
                            data: allYears.map((j: any) => res.data.find((k: any) => k["YEAR"] == j)?.["AFFISERT"] || 0),
                            tension: 0.5
                        },
                    ]
                });
            } else {
                setData(undefined);
            }
            
            props.onDataLoaded?.(res.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getData();
        }
    }, [auth.selectedBreed, auth.selectedCountry]);

    return (
        <div className={styles.statisticshealth} style={{ display: data == undefined || data.length == 0 ? "none" : "block" }}>
            <LineGraphCard
                title={t("statistics.areas.health.graphs.ataksi.distributionyear.title")}
                data={data}
                description={t("statistics.areas.health.graphs.ataksi.distributionyear.description")}
            ></LineGraphCard>
        </div>
    );
}

class HealthCardAtaksiDistributionYearProps {
    onDataLoaded?: (data: any) => void;
}

export default HealthCardAtaksiDistributionYear;